import { useState } from 'react'

let id = 0

function generateId() {
  return ++id
}

export function useId(): string {
  const [id] = useState(generateId)

  return '' + id
}
